<template>
    <div class="home">
        <div class="container">
            <div class="columns is-centered">
                <div class="column">
                    <div class="columns">
                        <ValidationObserver v-slot="{ errors }" tag="div">
                            <input-form
                            ref="form"
                            :errors="errors"
                            name="TenantIncome"
                            @submit.prevent="addTenant"
                            >
                            <div class="content">
                                <br>
                                        
                                        <div>
                                        <h1>Adult (18 and Over) - {{ tenantId }}</h1>
                                                <br>
                                                <h6>Please fill out the chart below with the names and birth dates of all adults living in the unit. Note: All adults must appear on the lease, except for the legal dependents of leaseholders as claimed on the most recent federal income tax return or legal minor children of leaseholders.</h6>
                                                <br>
                                            <div
                                            class="columns"
                                            >
                                            <div class="column">
                                                <vee-textbox
                                                v-model="currTenant.FirstName"
                                                mode="eager"
                                                :name="`txt-tenant-${tenantId}-first-name`"
                                                placeholder="First Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            <div class="column">
                                                <vee-textbox
                                                v-model="currTenant.LastName"
                                                mode="eager"
                                                :name="`txt-tenant-${tenantId}-last-name`"
                                                placeholder="Last Name"
                                                rules="required"
                                                required
                                                error="This field is required"
                                                />
                                            </div>
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <vee-dropdown
                                                    v-model="currTenant.Race"
                                                    :name="`dropdown-tenant-${tenantId}-race`"
                                                    label="Race"
                                                    :options="MultipleChoiceFieldOptions.Race"
                                                    rules="required"
                                                    required
                                                    placeholder="Race"
                                                    />
                                                </div>
                                                <div class="column">
                                                    <vee-dropdown
                                                    v-model="currTenant.Ethnicity"
                                                    :name="`dropdown-tenant-${tenantId}-ethnicity`"
                                                    label="Ethnicity"
                                                    :options="MultipleChoiceFieldOptions.Ethnicity"
                                                    rules="required"
                                                    required
                                                    placeholder="Ethnicity"
                                                    />
                                                </div>
                                                <div class="column">
                                                    <vee-textbox
                                                    v-model="currTenant.DateOfBirth"
                                                    :name="`text-tenant-${tenantId}-date-of-birth`"
                                                    label="Date of Birth"
                                                    rules="required"
                                                    required
                                                    placeholder="Date of Birth"
                                                    type="date"
                                                    />
                                                </div>
                                                
                                            </div>
                                            <div class="columns">
                                                <div class="column">
                                                    <vee-dropdown
                                                    v-model="currTenant.HasIncome"
                                                    :name="`text-tenant-${tenantId}-zero-income`"
                                                    label="Do you have any income?"
                                                    :options="MultipleChoiceFieldOptions.YesNo"
                                                    rules="required"
                                                    required
                                                    placeholder="Do you have any income?"
                                                    @change="onNo"
                                                    />
                                                </div>
                                                <div class="column">
                                                    <vee-dropdown
                                                    v-model="currTenant.HasTaxes"
                                                    :name="`dropdown-tenant-${tenantId}-has-taxes`"
                                                    label="Have you filed taxes in the last two years?"
                                                    :options="MultipleChoiceFieldOptions.YesNo"
                                                    @click="onNo"
                                                    rules="required"
                                                    required
                                                    placeholder="Have you filed taxes in the last two years?"
                                                    />
                                                </div>
                                                <div class="column" v-if="currTenant.HasTaxes != 'No'">
                                                    <vee-textbox
                                                    v-model="currTenant.GrossTaxes"
                                                    :name="`text-tenant-${tenantId}-gross-taxes`"
                                                    label="Gross Tax Amount"
                                                    rules="required"
                                                    required
                                                    placeholder="Gross Tax Amount"
                                                    />
                                                </div>
                                            </div>

                                <div class="columns" style="margin-left: 0%;">
                                    <div class="column" v-if="currTenant.HasTaxes != 'No'">
                                        <h4>Tax Return <i style="color: #cc3000;">(required)</i></h4>
                                        <file-upload
                                            ref="upload"
                                            v-model="currTenant.TaxReturn"
                                            :input-id="`file-tax-return`"
                                            extensions="gif,jpg,jpeg,png,webp,pdf"
                                            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                            label="File"
                                            @input-filter="inputFilter"
                                            >
                                            <button class="button is-primary" style="margin-bottom: 1%;">
                                            <i class="fa fa-plus"></i>
                                            &nbsp; Select File to Upload
                                            </button>
                                    </file-upload>
                                    <li v-for="file in currTenant.TaxReturn" :key="file.id">
                                        <span>{{ file.name }} - </span>
                                        <span
                                            v-if="file.error"
                                            class="is-love-park-red"
                                        >
                                            Something went wrong - {{ file.errorMessage }}
                                        </span>

                                        <span
                                            v-else-if="file.success"
                                            class="is-phanatic-green"
                                        >
                                            Upload Successful.
                                        </span>
                                        <span
                                            v-else-if="file.uploading"
                                            class="is-flyers-orange"
                                        >
                                            Uploading Document...</span>
                                        </li>
                                    </div>
                                    <div class="column">
                                            <h4>State Issued ID <i style="color: #cc3000;">(required)</i></h4>
                                            <file-upload
                                                ref="upload"
                                                v-model="currTenant.ID"
                                                :input-id="`file-id`"
                                                extensions="gif,jpg,jpeg,png,webp,pdf"
                                                accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                label="File"
                                                @input-filter="inputFilter"
                                                >
                                                <button class="button is-primary" style="margin-bottom: 1%;">
                                                <i class="fa fa-plus"></i>
                                                &nbsp; Select File to Upload
                                                </button>
                                        </file-upload>
                                        <li v-for="file in currTenant.ID" :key="file.id">
                                            <span>{{ file.name }} - </span>
                                            <span
                                                v-if="file.error"
                                                class="is-love-park-red"
                                            >
                                                Something went wrong - {{ file.errorMessage }}
                                            </span>

                                            <span
                                                v-else-if="file.success"
                                                class="is-phanatic-green"
                                            >
                                                Upload Successful.
                                            </span>
                                            <span
                                                v-else-if="file.uploading"
                                                class="is-flyers-orange"
                                            >
                                                Uploading Document...</span>
                                            </li>
                                    </div>
                                    <div class="column">
                                        <h4>Credit Report <i style="color: #cc3000;">(required)</i></h4>
                                            <file-upload
                                                ref="upload"
                                                v-model="currTenant.CreditReport"
                                                :input-id="`file-credit-report`"
                                                extensions="gif,jpg,jpeg,png,webp,pdf"
                                                accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                label="File"
                                                @input-filter="inputFilter"
                                                >
                                                <button class="button is-primary" style="margin-bottom: 1%;">
                                                <i class="fa fa-plus"></i>
                                                &nbsp; Select File to Upload
                                                </button>
                                        </file-upload>
                                        <li v-for="file in currTenant.CreditReport" :key="file.id">
                                            <span>{{ file.name }} - </span>
                                            <span
                                                v-if="file.error"
                                                class="is-love-park-red"
                                            >
                                                Something went wrong - {{ file.errorMessage }}
                                            </span>

                                            <span
                                                v-else-if="file.success"
                                                class="is-phanatic-green"
                                            >
                                                Upload Successful.
                                            </span>
                                            <span
                                                v-else-if="file.uploading"
                                                class="is-flyers-orange"
                                            >
                                                Uploading Document...</span>
                                            </li>
                                        </div>
                                </div>
                                <div class="columns" style="margin-left: 0%;">
                                <div class="column" v-if="currTenant.HasIncome == 'No'">
                                    <h4>Certificate of Zero Income <i style="color: #cc3000;">(required)</i></h4>
                                    <file-upload
                                        ref="upload"
                                        v-model="currTenant.ZeroIncomeCert"
                                        :input-id="`file-no-income-cert`"
                                        extensions="gif,jpg,jpeg,png,webp,pdf"
                                        accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                        label="File"
                                        @input-filter="inputFilter"
                                        >
                                        <button class="button is-primary" style="margin-bottom: 1%;">
                                        <i class="fa fa-plus"></i>
                                        &nbsp; Select File to Upload
                                        </button>
                                    </file-upload>
                                    <li v-for="file in currTenant.ZeroIncomeCert" :key="file.id">
                                        <span>{{ file.name }} - </span>
                                        <span
                                            v-if="file.error"
                                            class="is-love-park-red"
                                        >
                                            Something went wrong - {{ file.errorMessage }}
                                        </span>

                                        <span
                                            v-else-if="file.success"
                                            class="is-phanatic-green"
                                        >
                                            Upload Successful.
                                        </span>
                                        <span
                                            v-else-if="file.uploading"
                                            class="is-flyers-orange"
                                        >
                                            Uploading Document...</span>
                                        </li>
                                    </div>
                                </div>
                                    </div>
                                    <br>   
                                    <div v-if="currTenant.HasIncome != 'No'">
                                        <h2>Annual Income</h2>
                                        <div class="object-border income-information">
                                            <div
                                            v-for="income in currTenant.Incomes"
                                            :key="income.id"
                                            :class="`income-information-${income.id}`"
                                            >
                                            <div>
                                                <div v-if="income.id > 1">
                                                </div>
                                                <h3>Income Source - {{ income.id }}</h3>
                                                <div class="columns">
                                                    <div class="column">
                                                        <vee-dropdown
                                                        v-model="income.IncomeType"
                                                        mode="eager"
                                                        :id="`txt-income-type-${income.id}`"
                                                        :name="`txt-income-type-${income.id}`"
                                                        placeholder="Type Of Income"
                                                        :options="incomeType"
                                                        required
                                                        rules="required"
                                                        error="This field is required"
                                                        />
                                                    </div>
                                                    <div class="column">
                                                        <vee-textbox
                                                        v-model="income.Income"
                                                        mode="eager"
                                                        :name="`txt-income-${income.id}`"
                                                        placeholder="Estimated Annual Income"
                                                        required
                                                        rules="doubleCurrency|required"
                                                        error="This field is required"
                                                        type="number"
                                                        />
                                                    </div>
                                                    <div class="column" v-if="income.IncomeType === 'Employment'">
                                                        <vee-dropdown
                                                        v-model="income.PayFrequency"
                                                        mode="eager"
                                                        :name="`dropdown-pay-frequency-${income.id}`"
                                                        placeholder="Are you paid weekly or bi-weekly?"
                                                        :options="incomePayFrequency"
                                                        @change="onBiWeekly(income)"
                                                        required
                                                        rules="required"
                                                        error="This field is required"
                                                        />
                                                    </div>
                                                </div>
                                                <div class="columns" style="margin-left: 0%;" v-if="income.IncomeType === 'Employment'">
                                                    <div class="column">
                                                    <h4>Pay Stub 1 <i style="color: #cc3000;">(required)</i></h4>
                                                        <file-upload
                                                            ref="upload"
                                                            v-model="income.PayStub"
                                                            :input-id="`file-pay-stub-${income.id}`"
                                                            extensions="gif,jpg,jpeg,png,webp,pdf"
                                                            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                            label="File"
                                                            @input-filter="inputFilter"
                                                            >
                                                            <button class="button is-primary" style="margin-bottom: 1%;">
                                                            <i class="fa fa-plus"></i>
                                                            &nbsp; Select Files to Upload
                                                            </button>
                                                    </file-upload>
                                                    <li v-for="file in income.PayStub" :key="file.id">
                                                        <span>{{ file.name }} - </span>
                                                        <span
                                                            v-if="file.error"
                                                            class="is-love-park-red"
                                                        >
                                                            Something went wrong - {{ file.errorMessage }}
                                                        </span>

                                                        <span
                                                            v-else-if="file.success"
                                                            class="is-phanatic-green"
                                                        >
                                                            Upload Successful.
                                                        </span>
                                                        <span
                                                            v-else-if="file.uploading"
                                                            class="is-flyers-orange"
                                                        >
                                                            Uploading Document...</span>
                                                        </li>
                                                    </div>
                                                    
                                                    <div class="column">
                                                    <h4>Pay Stub 2 <i style="color: #cc3000;">(required)</i></h4>
                                                        <file-upload
                                                            ref="upload"
                                                            v-model="income.PayStub2"
                                                            :input-id="`file-pay-stub2-${income.id}`"
                                                            extensions="gif,jpg,jpeg,png,webp,pdf"
                                                            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                            label="File"
                                                            @input-filter="inputFilter"
                                                            >
                                                            <button class="button is-primary" style="margin-bottom: 1%;">
                                                            <i class="fa fa-plus"></i>
                                                            &nbsp; Select Files to Upload
                                                            </button>
                                                    </file-upload>
                                                    <li v-for="file in income.PayStub2" :key="file.id">
                                                        <span>{{ file.name }} - </span>
                                                        <span
                                                            v-if="file.error"
                                                            class="is-love-park-red"
                                                        >
                                                            Something went wrong - {{ file.errorMessage }}
                                                        </span>

                                                        <span
                                                            v-else-if="file.success"
                                                            class="is-phanatic-green"
                                                        >
                                                            Upload Successful.
                                                        </span>
                                                        <span
                                                            v-else-if="file.uploading"
                                                            class="is-flyers-orange"
                                                        >
                                                            Uploading Document...</span>
                                                        </li>
                                                    </div>
                                                    <div class="column" v-if="income.PayFrequency == 'Weekly'">
                                                    <h4>Pay Stub 3 <i style="color: #cc3000;">(required)</i></h4>
                                                        <file-upload
                                                            ref="upload"
                                                            v-model="income.PayStub3"
                                                            :input-id="`file-pay-stub3-${income.id}`"
                                                            extensions="gif,jpg,jpeg,png,webp,pdf"
                                                            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                            label="File"
                                                            @input-filter="inputFilter"
                                                            >
                                                            <button class="button is-primary" style="margin-bottom: 1%;">
                                                            <i class="fa fa-plus"></i>
                                                            &nbsp; Select Files to Upload
                                                            </button>
                                                    </file-upload>
                                                    <li v-for="file in income.PayStub3" :key="file.id">
                                                        <span>{{ file.name }} - </span>
                                                        <span
                                                            v-if="file.error"
                                                            class="is-love-park-red"
                                                        >
                                                            Something went wrong - {{ file.errorMessage }}
                                                        </span>

                                                        <span
                                                            v-else-if="file.success"
                                                            class="is-phanatic-green"
                                                        >
                                                            Upload Successful.
                                                        </span>
                                                        <span
                                                            v-else-if="file.uploading"
                                                            class="is-flyers-orange"
                                                        >
                                                            Uploading Document...</span>
                                                        </li>
                                                    </div>
                                                    <div class="column" v-if="income.PayFrequency == 'Weekly'">
                                                    <h4>Pay Stub 4 <i style="color: #cc3000;">(required)</i></h4>
                                                        <file-upload
                                                            ref="upload"
                                                            v-model="income.PayStub4"
                                                            :input-id="`file-pay-stub4-${income.id}`"
                                                            extensions="gif,jpg,jpeg,png,webp,pdf"
                                                            accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                            label="File"
                                                            @input-filter="inputFilter"
                                                            >
                                                            <button class="button is-primary" style="margin-bottom: 1%;">
                                                            <i class="fa fa-plus"></i>
                                                            &nbsp; Select Files to Upload
                                                            </button>
                                                    </file-upload>
                                                    <li v-for="file in income.PayStub4" :key="file.id">
                                                        <span>{{ file.name }} - </span>
                                                        <span
                                                            v-if="file.error"
                                                            class="is-love-park-red"
                                                        >
                                                            Something went wrong - {{ file.errorMessage }}
                                                        </span>

                                                        <span
                                                            v-else-if="file.success"
                                                            class="is-phanatic-green"
                                                        >
                                                            Upload Successful.
                                                        </span>
                                                        <span
                                                            v-else-if="file.uploading"
                                                            class="is-flyers-orange"
                                                        >
                                                            Uploading Document...</span>
                                                        </li>
                                                    </div>
                                                </div>
                                                <div class="columns" style="margin-left: 0%;">
                                        <div class="column" v-if="income.IncomeType != 'Employment'">
                                            <h4>Proof of Income <i style="color: #cc3000;">(required)</i></h4>
                                            <file-upload
                                                ref="upload"
                                                v-model="income.ProofOfIncome"
                                                :input-id="`file-proof-of-income-${income.id}`"
                                                extensions="gif,jpg,jpeg,png,webp,pdf"
                                                accept="image/png,image/gif,image/jpeg,image/webp,application/pdf"
                                                label="File"
                                                @input-filter="inputFilter"
                                                >
                                                <button class="button is-primary" style="margin-bottom: 1%;">
                                                <i class="fa fa-plus"></i>
                                                &nbsp; Select File to Upload
                                                </button>
                                        </file-upload>
                                        <li v-for="file in income.ProofOfIncome" :key="file.id">
                                            <span>{{ file.name }} - </span>
                                            <span
                                                v-if="file.error"
                                                class="is-love-park-red"
                                            >
                                                Something went wrong - {{ file.errorMessage }}
                                            </span>

                                            <span
                                                v-else-if="file.success"
                                                class="is-phanatic-green"
                                            >
                                                Upload Successful.
                                            </span>
                                            <span
                                                v-else-if="file.uploading"
                                                class="is-flyers-orange"
                                            >
                                                Uploading Document...</span>
                                            </li>
                                    </div>
                                    </div>
                                                <button
                                                    type="button"
                                                    class="button is-danger is-secondary"
                                                    :disabled="SubmitStatus.Value == SubmitStatus.Options.PENDING"
                                                    @click="removeIncome(income.id, currTenant.Incomes)"
                                                >
                                                    <i class="fa fa-solid fa-trash"></i>
                                                </button>
                                                <br>
                                                </div>
                                            </div>
                                            <div v-if="currTenant.Incomes.length > 0">
                                                <br>
                                            </div>
                                                <button
                                                    type="button"
                                                    class="button is-success is-secondary"
                                                    :disabled="SubmitStatus.Value == SubmitStatus.Options.PENDING"
                                                    @click="addIncome(currTenant.Incomes.length, currTenant.Incomes)"
                                                >
                                                    <i class="fa fa-solid fa-plus"></i>
                                                </button>
                                        </div>
                                        <br>
                                    </div>
                                    <!-- <div v-if="currTenant.HasIncome != 'No'">
                                    <h2>Gross Income from Tax Return</h2>
                                    <div class="object-border tax-information">
                                        <div
                                        v-for="taxes in currTenant.GrossTaxes"
                                        :key="taxes.id"
                                        :class="`tax-information-${taxes.id}`"
                                        >
                                        <div>
                                            <div v-if="taxes.id > 1">
                                            </div>
                                            <h3>Gross Taxes - {{ taxes.id }}</h3>
                                            <div class="columns">
                                                <div class="column">
                                                    <vee-textbox
                                                    v-model="taxes.GrossAmount"
                                                    mode="eager"
                                                    :name="`txt-taxes-${taxes.id}`"
                                                    placeholder="Gross Amount"
                                                    required
                                                    rules="doubleCurrency|required"
                                                    error="This field is required"
                                                    type="number"
                                                    />
                                                </div>
                                            </div>
                                            
                                            <button
                                                type="button"
                                                class="button is-danger is-secondary"
                                                :disabled="SubmitStatus.Value == SubmitStatus.Options.PENDING"
                                                @click="removeTaxes(taxes.id, currTenant.GrossTaxes)"
                                            >
                                                <i class="fa fa-solid fa-trash"></i>
                                            </button>
                                            <br>
                                            </div>
                                        </div>
                                        <div v-if="currTenant.GrossTaxes.length >= 1">
                                            <br>
                                        </div>
                                            <button
                                                type="button"
                                                class="button is-success is-secondary"
                                                :disabled="SubmitStatus.Value == SubmitStatus.Options.PENDING"
                                                @click="addTaxes(currTenant.GrossTaxes.length, currTenant.GrossTaxes)"
                                            >
                                                <i class="fa fa-solid fa-plus"></i>
                                            </button>
                                        </div>
                                    </div> -->
                                        <br>
                                <div class="columns" style="margin-left: 0%;" >
                                </div>
                            </div>
                            <template #submit>
                                <div class="action columns">
                                        <div v-if="FullApplication.TenantList.length > 1" class="column" style="text-align: start;">
                                            <button
                                            type="button"
                                            class="button is-danger"
                                            :disabled="SubmitStatus.Value == SubmitStatus.Options.PENDING"
                                            @click="removeTenant(tenantId, FullApplication.TenantList)"
                                            >
                                            Remove Tenant
                                            </button>
                                        </div>
                                        <div v-if="FullApplication.TenantList.length <= Number(tenantId)" class="column" style="text-align: end;">
                                            <button
                                                type="button"
                                                class="button is-success"
                                                :disabled="(currTenant.HasIncome != 'No' && (currTenant.Incomes.length < 1 || currTenant.CreditReport.length < 1 || currTenant.ID.length < 1 || removePaySubs())) || (currTenant.HasIncome == 'No' && (currTenant.CreditReport.length < 1 || currTenant.ID.length < 1 || currTenant.ZeroIncomeCert.length < 1)) || (currTenant.HasTaxes != 'No' && (currTenant.TaxReturn.length < 1))"
                                                @click="addTenant"
                                            >
                                            Add Tenant
                                            </button>
                                        </div>
                                    </div>
                                    <div class="action columns">
                                        <div v-if="tenantId == 1" class="column" style="text-align: start;">
                                            <button
                                                type="button"
                                                class="button is-primary"
                                                @click="previousSection"
                                            >
                                            <i class="fa fa-solid fa-arrow-left" style="font-size: x-large;"></i>
                                            </button>
                                        </div>
                                        <div v-if="Number(tenantId) > 1" class="column" style="text-align: start;">
                                            <button
                                            type="button"
                                            class="button is-primary"
                                            @click="previousTenant"
                                            >
                                            <i class="fa fa-solid fa-arrow-left" style="font-size: x-large;"></i>
                                            </button>
                                        </div>
                                        <div v-if="FullApplication.TenantList.length > Number(tenantId)" class="column" style="text-align: end;">
                                            <button
                                            type="button"
                                            class="button is-primary"
                                            @click="nextTenant"
                                            >
                                            <i class="fa fa-solid fa-arrow-right" style="font-size: x-large;"></i>
                                            </button>
                                        </div>
                                        <div v-if="FullApplication.TenantList.length <= Number(tenantId)" class="column" style="text-align: end;">
                                            <button
                                                type="button"
                                                class="button is-primary"
                                                :disabled="(currTenant.HasIncome != 'No' && (currTenant.Incomes.length < 1 || currTenant.CreditReport.length < 1 || currTenant.ID.length < 1 || removePaySubs())) || (currTenant.HasIncome == 'No' && (currTenant.CreditReport.length < 1 || currTenant.ID.length < 1 || currTenant.ZeroIncomeCert.length < 1)) || (currTenant.HasTaxes != 'No' && (currTenant.TaxReturn.length < 1))"
                                                @click="nextSection"
                                            >
                                            <i class="fa fa-solid fa-arrow-right" style="font-size: x-large;"></i>
                                            </button>
                                        </div>
                                    </div>
                                </template>
                            </input-form>
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FileUpload from "vue-upload-component";
import options from "@/utilities/options";
import * as incomeFunctions from "@/utilities/object-functions";
import Income from "@/utilities/classes/income";
//import Taxes from "@/utilities/classes/taxes";
import Tenant from "@/utilities/classes/tenant";

export default {
  name: 'TenantIncome',
  components: { FileUpload },
  mixins: [options],
  props: {
    tenantId: {
      default: null,
      type: String,
    },
  },
  data(){
    return{
        FullApplication: null,
        currTenant: null,
        checkPayStubs: null,
    }
  },
  async beforeMount(){
    window.scrollTo(0, 0);
    this.FullApplication = await this.$vlf.getItem('fullApplication');
    this.checkPayStubs = setInterval(() => {
        this.removePaySubs();
      }, 1000);

    // this.TenantArray = this.FullApplication.TenantList;
    // this.IncomeArray = this.TenantArray.Incomes;
    // this.TaxesArray = this.TenantArray.GrossTaxes;
    
    if(this.FullApplication.TenantList.length < this.tenantId){
        incomeFunctions.addTenant(this.tenantId - 1, this.FullApplication.TenantList);
    }
    this.currTenant = this.FullApplication.TenantList[this.tenantId - 1];
  },
  methods: {
    removePaySubs(){
        var incomes = this.currTenant.Incomes;
        var missingFile = true;
        for(var i = 0; i < incomes.length; i++){
            if(incomes[i].IncomeType === 'Employment'){
                incomes[i].ProofOfIncome = [];
                if(((incomes[i].PayFrequency == 'Bi-weekly' || incomes[i].PayFrequency == null) && (incomes[i].PayStub.length < 1 || incomes[i].PayStub2.length < 1)) || (incomes[i].PayFrequency == 'Weekly' && (incomes[i].PayStub.length < 1 || incomes[i].PayStub2.length < 1 || incomes[i].PayStub3.length < 1 || incomes[i].PayStub4.length < 1))){
                    missingFile = true;
                }
                else{
                    missingFile = false;
                }
            }
            else if(incomes[i].IncomeType != 'Employment'){
                incomes[i].PayStub = [];
                incomes[i].PayStub2 = [];
                incomes[i].PayStub3 = [];
                incomes[i].PayStub4 = [];
                if(incomes[i].ProofOfIncome.length < 1){
                    missingFile = true;
                }
                else{
                    missingFile = false;
                }
            }
            
        }
            return missingFile;
    },
    onBiWeekly(income){
        if(income.PayFrequency == 'Bi-weekly'){
            income.PayStub3 = [];
            income.PayStub4 = [];
        }
    },
    onNo(){
        if(this.currTenant.HasIncome == 'No'){
           this.currTenant.Incomes = [];
        }
        if(this.currTenant.HasIncome == 'Yes'){
           this.currTenant.ZeroIncomeCert = [];
        }
        if(this.currTenant.HasTaxes == 'No'){
            this.currTenant.TaxReturn = [];
            this.currTenant.GrossTaxes = null;
        }
    },
    // removeFile(fileIndex){
    //     var PayStub =this.currTenant.PayStub;
    //     if(fileIndex > -1){
    //         PayStub.splice(fileIndex, 1);
    //     }
        
    // },
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && !oldFile) {
        // Before adding a file
        // Filter system files or hide files
        if (/(\/|^)(Thumbs\.db|desktop\.ini|\..+)$/.test(newFile.name)) {
          return prevent();
        }
        // Filter php html js file
        if (/\.(php5?|html?|jsx?|exe?)$/i.test(newFile.name)) {
          return prevent();
        }
      }
    },
    async SaveApplicationInfo(){
        this.$vlf.removeItem('fullApplication');
        await this.$vlf.setItem('fullApplication', this.FullApplication);
    },
    async nextSection(){
        this.currTenant = null;
        const isInputValid = await this.$refs.form.$parent.validate();
        if (isInputValid) {
            await this.SaveApplicationInfo();
            clearInterval(this.checkPayStubs);
            this.$router.push({
                name: "ChildInfo",
            });
        }
    },
    async nextTenant(){
        const isInputValid = await this.$refs.form.$parent.validate();
          if (isInputValid) {
            this.currTenant = this.FullApplication.TenantList[this.tenantId];
            await this.SaveApplicationInfo();
            window.scrollTo(0, 0);
            this.$router.push({
                name: "TenantIncome",
                params: { tenantId: Number(this.tenantId) + 1  },
            });
        }
    },
    async removeTenant(tenantId, tenantArray){
        this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
        if(tenantArray.length == 1){
            alert("Must have at least 1 adult.");
            this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
        }
        else{
            tenantArray.splice(tenantId - 1, 1);

            for(var i = tenantId  - 1; i < tenantArray.length; i++){
                tenantArray[i].id = tenantArray[i].id - 1;
            }
            await this.SaveApplicationInfo();
            clearInterval(this.checkPayStubs);
            this.currTenant = this.FullApplication.TenantList[this.tenantId - 2];
            if(tenantId > 1){
                this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
                window.scrollTo(0, 0);
                this.$router.push({
                name: "TenantIncome",
                params: { tenantId: Number(this.tenantId) - 1  },
                });
            } else{
                this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
                window.scrollTo(0, 0);
                location.reload()
            }
        }
    },
    async previousSection(){
        const isInputValid = await this.$refs.form.$parent.validate();
          if (isInputValid) {
            await this.SaveApplicationInfo();
            clearInterval(this.checkPayStubs);
            this.$router.push({
                name: "LeaseUpForm",
            });
        }
    },
    async previousTenant(){
        const isInputValid = await this.$refs.form.$parent.validate();
          if (isInputValid) {
            await this.SaveApplicationInfo();
            window.scrollTo(0, 0);
            clearInterval(this.checkPayStubs);
            this.currTenant = this.FullApplication.TenantList[this.tenantId - 2];
            this.$router.push({
                name: "TenantIncome",
                params: { tenantId: Number(this.tenantId) - 1  },
            });
        }
    },
    async addTenant(){
        const isInputValid = await this.$refs.form.$parent.validate();
          if (isInputValid) {
            this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
            await this.SaveApplicationInfo();
            const tenant = new Tenant(Number(this.tenantId) + 1);
            this.FullApplication.TenantList.push(tenant);
            this.currTenant = this.FullApplication.TenantList[this.tenantId];
            this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
            window.scrollTo(0, 0);
            clearInterval(this.checkPayStubs);
            this.$router.push({
                name: "TenantIncome",
                params: { tenantId: Number(this.tenantId) + 1  },
            });
        }
    },
    addIncome(incomeId, incomeArray){
        this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
        const income = new Income(incomeId + 1);
        incomeArray.push(income);

        if(incomeArray.length > 0){
           this.currTenant.ZeroIncomeCert = [];
        }
         this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
    },
    removeIncome(incomeId, incomeArray) {
        this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
        incomeArray.splice(incomeId - 1, 1);

        for(var i = incomeId  - 1; i < incomeArray.length; i++){
            incomeArray[i].id = incomeArray[i].id - 1;
        }

        this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
    },
    // addTaxes(taxId, taxesArray) {
    //     this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
   
    // const taxes = new Taxes(taxId + 1);
    // taxesArray.push(taxes);
    // this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
    // },
    // removeTaxes(taxId, taxesArray){
    // this.SubmitStatus.Value = this.SubmitStatus.Options.PENDING;
    
    // // if(taxesArray.length == 1){
    // //    alert("Must have at least 1 income source.") 
    // // }
    // // else{
    // taxesArray.splice(taxId - 1, 1);

    // for(var i = taxId  - 1; i < taxesArray.length; i++){
    //     taxesArray[i].id = taxesArray[i].id - 1;
    // }
    // this.SubmitStatus.Value = this.SubmitStatus.Options.OK;
    // //} 
    // }
  }
};

</script>

<style>
.object-border{
    border-width: 5px;
    border-style: solid;
    padding: 1%;
    border-radius: 10px;
    border-color: #0f4d90;
}
</style>
